import { useMutation } from "@tanstack/react-query";
import { getCustomerPortalUrl } from "@/api/endpoints/paymentGateway";

export function useOpenCustomerPortal() {
  return useMutation({
    mutationFn: getCustomerPortalUrl,
    onSuccess: (data) => {
      window.open(data.url, "_blank");
    },
  });
}
